module.exports = __webpack_public_path__ + "static/SLMFN-98a06d929eb5f1cb6ccc809b9beff6af.png";